import { Grid } from "semantic-ui-react";
import {
  buildQueryFromFilters,
  ScenarioContext,
} from "./ScenarioFilter.component";
import {
  AmProject,
  AmScenario,
  FilterDetails, extractProjectAndVersionIdFromStoreId,
  ProjectVersion,
} from "../../ps-types";
import { ScenarioFilters } from "../../../components/Filter/Filter.component";
import { useDashboardService } from "../builder/DashboardConfigService";
import { ProjectVersionSelection } from "../projects/ProjectVersionSelection";
import {useMemo} from "react";

interface AmScenarioFilterSectionProps {
  setScenarioTitle: (string: string) => void;
  selectedContextInternal: ScenarioContext,
  setSelectedContextInternal: (arg: ScenarioContext) => void;
  filtersMap: AmScenario["filtersMap"];
  paramsMap: AmScenario["paramsMap"];
  setClearButtonDisabled: (bool: boolean) => void;
  projects: AmProject[];
}

export function AmScenarioFilterSection({
  selectedContextInternal,
  setSelectedContextInternal,
  setScenarioTitle,
  filtersMap,
  paramsMap,
  setClearButtonDisabled,
  projects,
}: AmScenarioFilterSectionProps) {
  const { getService } = useDashboardService();
  const dService = getService();

  const handleChangeScenario = (value: ProjectVersion[]) => {
    const storeIds = value.map((p) => `p:${p.projectId}:${p.versionId}`);
    const filterDetails: FilterDetails = {
      filtersMap: (filtersMap as AmScenario["filtersMap"]) || {},
      initialFiltersMap:
        dService.getGlobalContext()?.filterDetails?.initialFiltersMap,
      filterQuery: buildQueryFromFilters(filtersMap),
    };
    setSelectedContextInternal({ storeIds, filterDetails, paramsMap });
    setScenarioTitle("Custom Selection");
    setClearButtonDisabled(false);
  };

  const memoizedScenarioFiltersComponent = useMemo(()=>{
    return <ScenarioFilters />
  }, [])

  return (
    <>
      <Grid.Row>
        <Grid.Column style={{ display: "flex" }}>
          {dService.getConfig().isProjectVersionSelectorExposed() && (
            <ProjectVersionSelection
              projects={projects}
              selectedProjectVersions={selectedContextInternal.storeIds.map(extractProjectAndVersionIdFromStoreId)}
              handleChange={handleChangeScenario}
            />
          )}
          {memoizedScenarioFiltersComponent}
        </Grid.Column>
      </Grid.Row>
    </>
  );
}
